import axios from 'axios';

class ApiService {
  static INSTANCE;

  static getInstance = () => {
    if (!ApiService.INSTANCE) ApiService.INSTANCE = new ApiService();
    return ApiService.INSTANCE;
  };

  constructor() {
    this.allBillerApiService = axios.create({
      baseURL: process.env.ANTEIKU_URL,
      timeout: 15000,
    });
    this.amonraApiService = axios.create({
      baseURL: process.env.AMONRA_URL,
      timeout: 15000,
    });
    this.aurumApiService = axios.create({
      baseURL: process.env.AURUM_URL,
      timeout: 15000,
    });
    this.auth0ApiService = axios.create({
      baseURL: `https://${process.env.AUTH0_DOMAIN}`,
      timeout: 15000,
    });
    this.deliveryApiService = axios.create({
      baseURL: process.env.ARGONAUTS_URL,
      timeout: 15000,
    });
    this.cdnApiService = axios.create({
      baseURL: process.env.CDN_URL,
      timeout: 15000,
    });
  }

  setToken = (service, token) => {
    if (service === 'deliveryApiService')
      this[service].defaults.headers.common = {
        Authorization: `Bearer ${token}`,
        'X-Target-Env': process.env.ENV,
        'X-Target-Client': 'BO',
      };
    else
      this[service].defaults.headers.common = {
        Authorization: `Bearer ${token}`,
      };
  };
}

export default ApiService;
